import { Link, useNavigate } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import Logo from "./Logo";

const Navbar = () => {
  const { t, lang, setLang } = useLang();
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-xl bg-[#F4F1EB]/85 border-b border-[#0A1128]/5"
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center group" data-testid="brand-link">
          <Logo size={52} variant="horizontal-blue" />
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          <a href="/#services" className="link-underline text-sm text-[#0A1128]/80 hover:text-[#0A1128]" data-testid="nav-services">
            {t.nav.services}
          </a>
          <a href="/#houses" className="link-underline text-sm text-[#0A1128]/80 hover:text-[#0A1128]" data-testid="nav-houses">
            {t.nav.houses}
          </a>
          <a href="/#contact" className="link-underline text-sm text-[#0A1128]/80 hover:text-[#0A1128]" data-testid="nav-contact">
            {t.nav.contact}
          </a>
        </nav>

        <div className="flex items-center gap-5">
          <div className="hidden sm:flex items-center gap-1 text-xs tracking-[0.18em]" data-testid="lang-toggle">
            <button
              onClick={() => setLang("pt")}
              className={`transition-colors ${lang === "pt" ? "text-[#C5A059]" : "text-[#0A1128]/50 hover:text-[#0A1128]"}`}
              data-testid="lang-toggle-pt"
            >
              PT
            </button>
            <span className="text-[#0A1128]/30">|</span>
            <button
              onClick={() => setLang("en")}
              className={`transition-colors ${lang === "en" ? "text-[#C5A059]" : "text-[#0A1128]/50 hover:text-[#0A1128]"}`}
              data-testid="lang-toggle-en"
            >
              EN
            </button>
          </div>

          {user && user.id ? (
            <>
              {user.role === "admin" ? (
                <Link
                  to="/admin"
                  className="hidden sm:inline text-xs uppercase tracking-widest text-[#0A1128]/80 hover:text-[#C5A059]"
                  data-testid="nav-admin"
                >
                  {t.nav.admin}
                </Link>
              ) : (
                <Link
                  to="/dashboard"
                  className="hidden sm:inline text-xs uppercase tracking-widest text-[#0A1128]/80 hover:text-[#C5A059]"
                  data-testid="nav-dashboard"
                >
                  {t.nav.dashboard}
                </Link>
              )}
              <button
                onClick={handleLogout}
                className="text-xs uppercase tracking-widest text-[#0A1128]/70 hover:text-[#0A1128]"
                data-testid="nav-logout"
              >
                {t.nav.logout}
              </button>
            </>
          ) : (
            <Link
              to="/login"
              className="bg-[#0A1128] text-[#FCFAF8] hover:bg-[#162243] transition-colors duration-300 px-5 md:px-7 py-3 text-xs tracking-[0.2em] uppercase"
              data-testid="nav-login"
            >
              {t.nav.login}
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};

export default Navbar;
